import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { TopBar } from "./TopBar";
import { SiteHeader } from "./SiteHeader";
import { MainNav } from "./MainNav";
import { Ticker } from "./Ticker";
import { SiteFooter } from "./SiteFooter";

export const PublicLayout = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return (
    <div className="min-h-screen flex flex-col">
      <TopBar />
      <SiteHeader />
      <MainNav />
      <Ticker />
      <main className="flex-1 container-site py-8">
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  );
};
